import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Monitor, ArrowRight, Sparkles } from 'lucide-react';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';
const features = ["Complete hosting & SSL included", "Professional responsive design", "SEO optimization & analytics", "Ongoing content updates", "24/7 monitoring & support"];
export const WebsiteDetailPanel = () => {
  const {
    elementRef,
    getRevealStyle
  } = useScrollReveal();
  return <section style={{
    padding: 'var(--space-4xl) 0',
    background: 'hsl(var(--background))'
  }}>
      <div className="container">
        <div className="detail-panel" ref={elementRef}>
          <div className="detail-content">
            {/* Left Content Area - 60% */}
            <div className="detail-text">
              <div className="micro-label" style={getRevealStyle(0)}>
                WEBSITE-AS-A-SERVICE
              </div>
              
              <h3 style={{
              ...getRevealStyle(1),
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(32px, 4vw, 48px)',
              fontWeight: 700,
              lineHeight: 1.2,
              background: 'linear-gradient(135deg, #FFFFFF 0%, hsl(var(--primary)) 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              marginBottom: '24px'
            }}>
                Professional websites with everything included
              </h3>
              
              <p style={{
              ...getRevealStyle(2),
              color: 'rgba(255, 255, 255, 0.92)',
              fontSize: 'clamp(16px, 1.25vw, 18px)',
              lineHeight: 1.7
            }}>
                Get a complete digital presence without the complexity. Our Website-as-a-Service includes hosting, SSL, ongoing updates, and expert support—all for one predictable monthly fee.
              </p>

              {/* Features List */}
              <ul className="detail-features" style={getRevealStyle(3)}>
                {features.map((feature, index) => <li key={index} style={{
                color: 'rgba(255, 255, 255, 0.95)'
              }}>
                    {feature}
                  </li>)}
              </ul>

              {/* CTA */}
              <div style={getRevealStyle(4)}>
                <Link to="/services/website-development" className="detail-cta">
                  <Sparkles className="w-4 h-4" />
                  Explore Website Services
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>

            {/* Right Illustration Area - 40% */}
            
          </div>
        </div>
      </div>
    </section>;
};